<!--Update Fleet Configuration Title-->
<h2>Update Fleet Configuration</h2>
<p>Account Id: {{accountId}}</p>
<p>Fleet Id: {{updateFleetConfigurationRequest.fleetId}}</p>
<mat-dialog-content>
    <!--Dialog Content-->
    <div *ngIf="!updateFleetConfigurationResponse">
        <form novalidate>
            <div class="form-field-div">
                <mat-form-field class="form-field">
                    <mat-label>State</mat-label>
                    <mat-select [(ngModel)]="updateFleetConfigurationRequest.state"
                        [ngModelOptions]="{standalone: true}">
                        <mat-option *ngFor="let item of fleetConstantClassCollection.fleetStateList" [value]="item">
                            <span>{{item}}</span>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="form-field-div">
                <mat-form-field class="form-field">
                    <mat-label>Access Policy</mat-label>
                    <mat-select [(ngModel)]="updateFleetConfigurationRequest.accessPolicy"
                        [ngModelOptions]="{standalone: true}">
                        <mat-option *ngFor="let item of fleetConstantClassCollection.fleetAccessPolicyList"
                            [value]="item">
                            {{item}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="form-field-div">
                <mat-form-field class="form-field">
                    <mat-label>Priority</mat-label>
                    <input type="number" matInput [(ngModel)]="updateFleetConfigurationRequest.priority"
                        [ngModelOptions]="{standalone: true}" />
                </mat-form-field>
            </div>
            <div class="form-field-div">
                <mat-form-field class="form-field">
                    <mat-label>Min Launch Capacity</mat-label>
                    <input type="number" matInput [(ngModel)]="updateFleetConfigurationRequest.minLaunchCapacity"
                        [ngModelOptions]="{standalone: true}" />
                </mat-form-field>
            </div>
        </form>
    </div>
    <div *ngIf="updateFleetConfigurationResponse">
        <span class="success">
            <mat-icon>check_circle</mat-icon> updated successfully
        </span>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <!--Dialog action buttons-->
    <button mat-raised-button color="primary" (click)="save()" [disabled]="isSaving"
        *ngIf="!updateFleetConfigurationResponse">
        <span *ngIf="!isSaving">Save</span>
        <span *ngIf="isSaving">Saving...</span>
    </button>
    <button mat-raised-button [disabled]="isSaving" (click)="close()">Cancel</button>
</mat-dialog-actions>